import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import { getServiceContent, groupedServices, servicePath } from '../../content/services';
import { localeFromPath, servicesRoot } from '../../lib/i18n-routes';

/**
 * Bosh sahifadagi xizmatlar bo'limi.
 *
 * Avval 4 ta raqamlangan statik kartochka edi. Endi barcha yozilgan
 * xizmatlar guruhlar bo'yicha chiqadi va har biri o'z sahifasiga olib
 * boradi — mijoz o'ziga keraklisini o'zi topadi. Raqamlash olib tashlandi:
 * bu ketma-ketlik emas, tanlov ro'yxati.
 */
function Work() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const locale = localeFromPath(pathname);

    const groups = groupedServices();
    const total = groups.reduce((n, g) => n + g.items.length, 0);

    if (!total) return null;

    return (
        <section id="xizmatlar" className="tf-section how-we-work">
            <div className="container">
                <div className="tf-title st2 mb-50" data-aos="fade-up" data-aos-duration="800">
                    <p className="h8 sub-title">{t('services')}</p>
                    <h2 className="title m-b17">{t('our-services')}</h2>
                    <p className="work-lead">{t('about-services')}</p>
                </div>

                {groups.map((group) => (
                    <div className="work-group" key={group.key}>
                        <h3 className="work-group__title">
                            <span>+</span>
                            {t(group.i18n)}
                        </h3>

                        <div className="work-grid">
                            {group.items.map((s) => {
                                const c = getServiceContent(s.slug, locale);
                                if (!c) return null;

                                return (
                                    <Link
                                        className="work-card"
                                        key={s.slug}
                                        to={servicePath(s, locale)}
                                    >
                                        <h4 className="work-card__title">{c.hero.h1}</h4>
                                        <p className="work-card__text">
                                            {c.definition?.text || c.meta.description}
                                        </p>
                                        <span className="work-card__more">
                                            {t('read-more')} &#8599;
                                        </span>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                ))}

                <div className="work-all">
                    <Link to={servicesRoot(locale)} className="tf-button btn-effect">
                        <span className="effect">{t('all-services')}</span>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default Work;
